import { inject, Injectable } from '@angular/core';
import { UrlTree, ActivatedRouteSnapshot, RedirectCommand, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';

import { UserProcessFacade } from '@state/user-process';

@Injectable()
export class DocumentsGuard {
  private readonly userProcessFacade = inject(UserProcessFacade);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree | RedirectCommand> {
    return this.userProcessFacade.myProcess$.pipe(
      filter(myProcess => !!myProcess?.id),
      take(1),
      switchMap(userProcess => {
        const allowedStatuses = route.data?.allowedUserProcessStatuses;

        if (!allowedStatuses.includes(userProcess?.status)) {
          const fallbackRoute = userProcess?.id ? ['/user-process', userProcess.id] : ['/user-process'];
          return of(new RedirectCommand(this.router.createUrlTree(fallbackRoute), { replaceUrl: true }));
        }
        const currVoivoId = userProcess.personalDetails.residenceVoivodeshipDetailsId;

        return this.userProcessFacade.documentsList$.pipe(
          tap(documentsList => {
            if (!documentsList) {
              this.userProcessFacade.getListOfDocuments(userProcess.id);
              return;
            }

            const documentInWrongVoivo = !!documentsList.processDocs.find(
              procDoc => procDoc.voivodeshipId !== currVoivoId
            );
            if (documentInWrongVoivo) {
              this.userProcessFacade.getListOfDocuments(userProcess.id);
            }
          }),
          filter(documentsList => {
            if (!documentsList) {
              return false;
            }

            const documentInWrongVoivo = !!documentsList.processDocs.find(
              procDoc => procDoc.voivodeshipId !== currVoivoId
            );
            return !documentInWrongVoivo;
          }),
          take(1),
          map(documentsList => !!documentsList?.processDocs)
        );
      })
    );
  }
}
